import AbstractValidator from './AbstractValidator';

export default class NotEmpty extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        isEmpty: 'Dieses Feld darf nicht leer sein.',
        notLess: 'Die Eingabe (%value%) ist nicht kleiner als %max%.',
    };

    run()
    {
        if (
            'undefined' === typeof this.value
            || null === this.value
            /* ||!this.value || breaks some select boxes - e.g. category 'Kategorielos' (value 0)*/
            || this.value.length === 0)
        {
            this.error = this.getMessage('isEmpty');
        }
    }
}